export default __webpack_public_path__ + "static/assets/000853e4f4cf983a3e8c1fe3d236c320.png";